module.exports = __webpack_public_path__ + "static/media/team-vadim.2a7b1194.jpg";